export interface PreselectedPaymentMethodInput {
  layout?: string | null;
  preselectFirstPaymentMethod?: boolean | null;
  preselectOnlyAvailableMethod?: boolean | null;
  paymentMethodCount?: number | null;
}

export const isPreselectedPaymentMethod = ({
  layout,
  preselectFirstPaymentMethod,
  preselectOnlyAvailableMethod,
  paymentMethodCount,
}: PreselectedPaymentMethodInput): boolean =>
  layout === 'amount-first' ||
  !!preselectFirstPaymentMethod ||
  (paymentMethodCount === 1 && !!preselectOnlyAvailableMethod);
